module.exports = __webpack_public_path__ + "media/images/checkout-step-background-active-426735b624ba16ce8037317e88125f24.png";